import classNames from "classnames";
import { useMemo } from "react";
import "./TagList.less";

interface TagListProps {
  auditTags?: string;
  theme?: "light" | "dark";
}

const TagList = ({ theme, auditTags }: TagListProps) => {
  const list: { name: string; code: string }[] = useMemo(() => {
    // 接口返回的tag列表是个json string，需要将其转为数组
    if (auditTags && typeof auditTags === "string") {
      try {
        return JSON.parse(auditTags);
      } catch (err) {
        console.error(err);
      }
    }
    return [];
  }, [auditTags]);

  if (!Array.isArray(list) || !list.length) {
    return null;
  }
  return (
    <div className={classNames("trend-detail-tags", theme)}>
      {list.map((tag) => (
        <span key={tag.code} className="tag">
          {tag.name}
        </span>
      ))}
    </div>
  );
};
export default TagList;
